/**
 * Definition of input types
 */
export enum INPUT_TYPE {
  SEARCH = 'search',
  PASSWORD = 'password',
}

/**
 * Definition of input themes
 */
export enum INPUT_THEME {
  LIGHT = 'light',
  DARK = 'dark',
  RED = 'red',
  DISABLED = 'disabled',
}

/**
 * Definition of input themes
 */
export enum INPUT_SIZE {
  NORMAL = 'normal',
  LARGE = 'large',
}
